__turbopack_context__.v({
  "Empty": "index-module__961qXq__Empty",
  "Input": "index-module__961qXq__Input",
  "Item": "index-module__961qXq__Item",
  "Label": "index-module__961qXq__Label",
  "List": "index-module__961qXq__List",
  "Popup": "index-module__961qXq__Popup",
  "Positioner": "index-module__961qXq__Positioner",
  "Scroller": "index-module__961qXq__Scroller",
  "VirtualizedPlaceholder": "index-module__961qXq__VirtualizedPlaceholder",
});
